@let form = block();
@let image = firstImage();
<div
  [formGroup]="form"
  class="grid grid-cols-1 gap-4 lg:grid-cols-[12rem_minmax(0,1fr)]">
  <div class="text-standard-text-secondary pt-3 pl-8 text-sm font-semibold">
    {{ cmsTextProvider.footer.logo }}
  </div>
  <div class="grid min-w-0 grid-cols-1 gap-4 lg:grid-cols-3">
    <aw-image-select
      [id]="'block-logo-image-' + index()"
      [formControl]="image.controls.image"
      [label]="cmsTextProvider.footer.imageSource" />
    <aw-translation-accessibility-text-input
      [entityType]="EntityType.footerPaymentArea"
      [relationType]="TextRelationType.imageAlt"
      [id]="'block-logo-alt-' + index()"
      [formControl]="image.controls.imageAlts"
      [label]="cmsTextProvider.footer.description" />
    <aw-text-input
      [id]="'block-logo-url-' + index()"
      [formControl]="image.controls.url"
      [label]="cmsTextProvider.footer.linkAddressLabel" />
  </div>
</div>
